var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 2.5C9.0835 2.5 8.3335 3.25 8.3335 4.16667C8.3335 5.08333 9.0835 5.83333 10.0002 5.83333C10.9168 5.83333 11.6668 5.08333 11.6668 4.16667C11.6668 3.25 10.9168 2.5 10.0002 2.5Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 14.1665C9.0835 14.1665 8.3335 14.9165 8.3335 15.8332C8.3335 16.7498 9.0835 17.4998 10.0002 17.4998C10.9168 17.4998 11.6668 16.7498 11.6668 15.8332C11.6668 14.9165 10.9168 14.1665 10.0002 14.1665Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 8.3335C9.0835 8.3335 8.3335 9.0835 8.3335 10.0002C8.3335 10.9168 9.0835 11.6668 10.0002 11.6668C10.9168 11.6668 11.6668 10.9168 11.6668 10.0002C11.6668 9.0835 10.9168 8.3335 10.0002 8.3335Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic_more.54147bb08bc94e04199534a89ee10795.svg";
export { ForwardRef as ReactComponent };